<header class="go-page-title">
  <h1 class="go-heading-1">{{ pageTitle }}</h1>
</header>
<section class="go-container">
  <go-card [showHeader]="false" class="go-column go-column--33">
    <div go-card-content>
      <p class="go-body-copy">
        The goDesign components represent complex implementations of our <a [routerLink]="['/standards']">goDesign standard elements</a>.
      </p>
      <p class="go-body-copy">
        Using a node module and <a class="go-link" href="https://www.npmjs.com">NPM</a> we will be able to distribute and 
        maintain our components quickly and efficiently.
      </p>
      <p class="go-body-copy">
        This methodology is heavily based on <a class="go-link" href="http://atomicdesign.bradfrost.com">Atomic Design</a>
        which lends itself towards thinking of our UIs as thoughtful hierarchies, discusses the qualities of
        effective pattern libraries, and showcases techniques to transform your team's design and development workflow.
      </p>
    </div>
  </go-card>
</section>
